import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c88902a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "audiosContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "exhitbtionImgBox"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "exhibition-box exhibition-container"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "typebox-col1"
};
const _hoisted_7 = {
  class: "type"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-cost"
}, null, -1));
const _hoisted_9 = {
  class: "type-name"
};
const _hoisted_10 = {
  class: "type"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-exhibit"
}, null, -1));
const _hoisted_12 = {
  class: "type-name"
};
const _hoisted_13 = {
  key: 0,
  class: "typebox-col2"
};
const _hoisted_14 = {
  class: "type"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-address"
}, null, -1));
const _hoisted_16 = {
  class: "type-name"
};
const _hoisted_17 = {
  class: "exhibiton-content"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "richtext",
  id: "editor1"
}, null, -1));
const _hoisted_19 = [_hoisted_18];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideTheme = _resolveComponent("guideTheme");
  const _component_audioItemv2 = _resolveComponent("audioItemv2");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audios ${_ctx.$route.query.searchKey ? 'searchKey' : ''}`)
  }, [_createVNode(_component_guideTheme), _createElementVNode("div", _hoisted_1, [!_ctx.$route.query.searchKey ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $options.getImg($data.detail.images, 750, 382)
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [!_ctx.$route.query.searchKey ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.language ? $data.detail.en_name : $data.detail.exhibName), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString($data.detail.price === '' ? '免费' : $data.detail.price), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(!$data.language ? $data.detail.exhibType : $options.getType($data.detail.exhibType)), 1)])]), $data.detail.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString($data.language ? $data.detail.en_location : $data.detail.exhibitionLocation), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    id: "desc",
    class: _normalizeClass(`txtcon ${$data.isFolded && $data.descflag ? 'hide' : ''}`)
  }, _hoisted_19, 2), _withDirectives(_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '展开全部'}` : `${this.language ? 'expand all' : '收起'}`), 1), _createElementVNode("i", {
    class: _normalizeClass(["icon-arrow-bottom1", {
      'up': !$data.isFolded
    }])
  }, null, 2)], 2), [[_vShow, $data.descflag]])])], 64)) : _createCommentVNode("", true), _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.total > 20 ? '已经到底了' : '',
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createVNode(_component_audioItemv2, {
      audioList: $data.audioList,
      formData: $data.formData,
      language: $data.language
    }, null, 8, ["audioList", "formData", "language"])]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])])])], 2);
}